import React from "react";

export default function Icon(props) {
    let viewBox = " 0 0 100 100",
        width = "14",
        height = "14",
        color = null;

    if (props.color) {
        color = props.color;
    }
    if (props.width) {
        width = props.width;
    }
    if (props.height) {
        height = props.height;
    }

    return (
        <svg
            className={props.className}
            height={height}
            onClick={props.onClick}
            style={props.style}
            title={props.title}
            viewBox={viewBox}
            width={width}
        >
            <use fill={color} xlinkHref={`#${props.iconId}`} />
        </svg>
    );
}
